<template>
    <div class="type-activity pb-8">
        <!-- header -->
        <div class="header-type 
        d-flex flex-wrap justify-space-between align-center">
                <div class="d-flex align-center mr-10">
                    <div  class="keyboard-return" v-if="isMobile()">
                        <v-btn
                        elevation="0"
                        icon
                        color="white"
                        @click="routePush('Lesson Detail', { id: lesson.lessonId })"
                        >
                        <v-icon>mdi-keyboard-return</v-icon>
                        </v-btn>
                    </div>
                    <v-btn
                        class=" text-uppercase text-subtitle-2"
                        color="primary"
                        elevation="0"
                        plain
                        @click="
                            routePush('LessonDetail', { id: lesson.lessonId })
                        "
                    >
                        {{ lesson.title }}
                        
                    </v-btn>
                    <v-icon class="text-subtitle-2 text-sm-subtitle-2  mr-3" color="white"
                        >mdi-chevron-right</v-icon
                    >
                    <span 
                    
                    class="text-subtitle-2 text-sm-subtitle-2  text-uppercase">{{
                        resource.activity.title
                    }}</span>
                </div>
                <div v-if="lesson.subject" class="d-flex align-center mr-5">
                        <span v-if="!isMobile()" class="text-subtitle-2 text-sm-subtitle-2 mr-5">{{ lesson.subject.name }}</span>
                        <span v-if="isMobile()" class="text-subtitle-2 text-sm-subtitle-2 mr-5">{{ lesson.subject.abbreviation }}</span>
                        <span class="text-subtitle-2 text-sm-subtitle-2 ">{{
                            lesson.section.nameAndCategoryName
                        }}</span>
                </div>
        </div>
        <!-- content -->
        <div class="container-sources">
            <v-row justify="center" class="container-src-1">
                <v-col 
                cols="12" 
                :lg="resource && resource.activity && resource.activity.instructive || resource.activity.isTask ?8:12" 
                class="container-src-2" >
                    <RomaText
                        class="roma-text"
                        :resource="resource"
                        v-if="$route.params.type === 'text'"

                    />
                    <RomaVideo
                        class="roma-video"
                        :resource="resource"
                        v-if="$route.params.type === 'video'"
                    />
                    <RomaFile
                        :resource="resource"
                        v-if="$route.params.type === 'file'"
                    />
                    <RomaEmbeddedLink
                        :resource="resource"
                        v-if="$route.params.type === 'link-embebido'"
                    />
                    <RomaLink
                        class="roma-link"
                        :resource="resource"
                        v-if="$route.params.type === 'link-externo'"
                    />
                </v-col>


                <v-col
                    v-if="resource.activity.instructive || resource.activity.isTask == true"
                    lg="4"
                    class="instructions pr-0 pr-sm-10 mt-3"
                >
                    <!-- Instructions -->

                    <v-row class=""  justify="center">
                        <v-container class="instructions-container">
                            <v-col cols="12" v-if="resource.activity.instructive">
                                <v-card-text>
                                    <h4 class="text-center font-weight-bold">
                                        Instrucciones
                                    </h4>
                                </v-card-text>

                                <v-row align="center" justify="center">
                                    <quillEditor
                                        class="rich-text-wrapper__editor"
                                        :content="resource.activity.instructive"
                                        :options="editorOption"
                                        :disabled="true"
                                    />
                                </v-row>
                            </v-col>
                            <v-col
                                cols="12"
                                v-if="resource.activity.isTask"
                            >
                                <v-row>
                                <v-card-text>
                                    <h4 class="text-center font-weight-bold">Enviar Tarea</h4>
                                </v-card-text>

                                <v-col cols="12">
                                    <div class=" px-2" style="pointer-events: none;">
                                            <TipTap :updateMode="{ readOnly: true, modules: {toolbar: true}, placeholder: ''}" />
                                    </div>
                                </v-col>
                                </v-row>

                                <v-row class=" px-2">
                                <v-col>
                                    <v-file-input
                                    placeholder="Subir Archivos"
                                    outlined
                                    dense
                                    chips
                                    counter
                                    multiple
                                    show-size
                                    truncate-length="15"
                                    :disabled="true"
                                    ></v-file-input>
                                </v-col>
                                <v-col>
                                    <v-btn
                                    block
                                    elevation="4"
                                    rounded
                                    :disabled="true"
                                    color="primary"
                                    >Enviar</v-btn
                                    >
                                </v-col>
                                </v-row>
                            </v-col>
                        </v-container>
                    </v-row>
                </v-col>
            </v-row>
        </div>

        <!-- footer - controles -->

            <div
                class="pagination-resources d-flex flex-wrap justify-center"
                :style="{ left: 'auto', right: 'auto' }"
            >

                <div  class="keyboard-return" v-if="!isMobile()">
                    <v-btn
                    elevation="0"
                    large
                    icon
                    class="btn-expand"
                    @click="routePush('Lesson Detail', { id: lesson.lessonId })"
                    >
                    <v-icon>mdi-keyboard-return</v-icon>
                    </v-btn>
                </div>
                
                <div class="d-flex flex-wrap align-center"> 
                    <v-btn
                        plain
                        elevation="0"
                        class="btn-arrow"
                        v-if="!previousPagination()"
                        @click="previous()"
                        disabled
                        large
                        
                    >
                        <v-icon>mdi-chevron-left</v-icon> Anterior</v-btn
                    >

                    <v-btn
                        elevation="0"
                        large
                        color="white"
                        class="btn-arrow"
                        v-if="previousPagination()"
                        @click="previous()"
                    >
                        <v-icon>mdi-chevron-left</v-icon> Anterior</v-btn
                    >

                    <p class="d-inline mx-4">
                        {{ this.resourceIndex + 1 }} / {{ this.resources.length }}
                    </p>

                    <v-btn
                        elevation="0"
                        large
                        color="white"
                        class="btn-arrow"
                        v-if="nextPagination()"
                        @click="next()"
                        >Siguiente <v-icon>mdi-chevron-right</v-icon></v-btn
                    >

                    <v-btn
                        elevation="0"
                        large
                        color="white"
                        class="btn-arrow"
                        v-if="!nextPagination()"
                        @click="next()"
                        disabled
                        >Siguiente <v-icon>mdi-chevron-right</v-icon></v-btn
                    >
                </div>


            </div>
    </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import TipTap from "@/components/commons/RomaTipTap";

import RomaText from "@/components/resource/RomaText";
import RomaVideo from "@/components/resource/RomaVideo";
import RomaFile from "@/components/resource/RomaFile";
import RomaEmbeddedLink from "@/components/resource/RomaEmbeddedLink";
import RomaLink from "@/components/resource/RomaLink";

import { mapActions, mapGetters } from "vuex";

export default {
    name: "TypeActivity",
    components: {
        RomaText,
        RomaVideo,
        RomaFile,
        RomaEmbeddedLink,
        RomaLink,
        quillEditor,
        TipTap
    },
    data() {
        return {
            expand: true,
            activityId: this.$route.params.id,
            editorOption: {
                readOnly: true,
                modules: {
                    toolbar: false
                },
                placeholder: ''
            }
        };
    },
    computed: {
        ...mapGetters({
            // getResource: "getResource",
            lesson: "getLesson",
            activity: "getCurrentActivity",
            resource: "getCurrentResource",
            resources: "getCurrentResources",
            resourceIndex: "getResourcePaginationIndex"
        })
    },
    mounted() {
        // this.getResourceById(this.activityId).then(() => {
        //   this.resource = this.getResource;
        // });
    },
    destroyed() {
        this.actionResetCurrentResource();
        this.actionSetResourcePaginationIndex(0);
    },
    methods: {
        ...mapActions({
            actionSetCurrentResource: "actionSetCurrentResource",
            actionSetResourcePaginationIndex:
                "actionSetResourcePaginationIndex",
            actionResetCurrentActivity: "actionResetCurrentActivity",
            actionResetCurrentResource: "actionResetCurrentResource"
        }),
        leftPagination() {
            const typeResource = this.$route.params.type;
            if (typeResource === "text") {
                return "45%";
            } else if (typeResource === "video") {
                return "35%";
            } else if (typeResource === "pdf") {
                return "45%";
            }
        },
        widthPagination() {
            const typeResource = this.$route.params.type;
            if (typeResource === "text") {
                return "28%";
            } else if (typeResource === "video") {
                return "28%";
            } else if (typeResource === "pdf") {
                return "28%";
            }
        },
        previousPagination() {
            // const typeResource = this.$route.params.type;
            // if (typeResource === "pdf") {
            //   return true;
            // } else return typeResource === "video";

            return this.resourceIndex == 0 ? false : true;
        },
        nextPagination() {
            return this.resources.length - (this.resourceIndex + 1) > 0
                ? true
                : false;
        },
        previous() {
            const previousResource = this.resources[this.resourceIndex - 1];
            this.actionSetResourcePaginationIndex(this.resourceIndex - 1);
            this.actionSetCurrentResource(previousResource);

            this.$router.push({
                name: "ActivityType",
                params: {
                    id: previousResource.resourcesId,
                    type: this.getUrlActivity(
                        previousResource.resourceType.type
                    )
                }
            });
            console.log("Atras");
        },
        next() {
            const nextResource = this.resources[this.resourceIndex + 1];
            this.actionSetResourcePaginationIndex(this.resourceIndex + 1);
            this.actionSetCurrentResource(nextResource);

            this.$router.push({
                name: "ActivityType",
                params: {
                    id: nextResource.resourcesId,
                    type: this.getUrlActivity(nextResource.resourceType.type)
                }
            });
            console.log("Siguiente");
        },
        ...mapActions({
            getResourceById: "getResourceById"
        }),
        isMobile(){
            const widthScreen = window.innerWidth;
            return widthScreen < 540 ? true: false;
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    padding: 0 !important;
}

.type-activity {
    height: 100%;
    .header-type {
        min-height: 30px;
        // padding: 0 15px;
        // line-height: 34px;
        background-color: #e97c21 ;
        // box-shadow: 0 3px 6px #0000001c;
        span {
            font-size: 20px;
            font-family: "Cabin", Regular !important;
            color: map-get($colors, "white");
        }
        .subject {
            font-size: 18px;
        }
        .grade {
            // margin-left: 10px;
            // border-radius: 50px;
            // padding: 8px 2px;
            // margin-right: 15px;
            // width: 35px;
            // height: 35px;
            // line-height: 14px;
            // background: #d56d16 0 0 no-repeat padding-box;
            // text-align: center;
            // font-size: 17px;
            // font-family: "Cabin", Regular !important;
            // letter-spacing: 0;
            // color: #ffffff;
        }
        .btn-back {
            text-align: left;
            font-size: 20px;
            font-family: "Cabin", Regular !important;
            letter-spacing: 0;
            color: #e97c21;
        }
    }
    .container-sources {
        // padding: 20px;
        position: relative;
        height: 100%;

        .container-src-1{
            height: 100%;
            .container-src-2{
                padding-right: 20px;
                padding-left: 20px;
                // height: 100%;  
                .roma-text{
                height: 100%;

                }
                .roma-link{
                height: 100%;

                }
                .roma-video{
                    margin: 10px;
                }
            }
        }
 
    }

    .pagination-resources {
        z-index: 5;
        border-radius: 10px;
        position: sticky;
        bottom: 5px;
        margin-left: auto;
        margin-right: auto; 
        background: white 0 0 no-repeat padding-box;
        box-shadow: 0 6px 10px #0000003b;
        max-width: 450px;

        // padding: 0 20px;
        
        .btn-arrow {
            // margin: 0px 15px;
            // height: 56px;
            // width: 150px;
            // margin-right: 10px;
            background: #ffffff 0 0 no-repeat padding-box;
            box-shadow: 0 6px 15px #00000029;
            border-radius: 33px;
            opacity: 1;
            color: #590564;
            text-transform: capitalize;
            font: Medium 18px/22px Cabin;
        }
        .btn-expand {
            // margin: 0px 25px 0px 10px;
            height: 56px;
            width: 65px;
            background: #ffffff 0 0 no-repeat padding-box;
            box-shadow: 0 6px 15px #00000029;
            border-radius: 100px;
            opacity: 1;
            color: #590564;
            text-transform: capitalize;
            font: Medium 18px/22px Cabin;
        }
    }
    .roma-icon-back:before {
        content: url("../../assets/icons/back.svg");
    }
}

.instructions-container {
  background: #ffffff;
//   margin-bottom: 100px;
  word-break: normal;
  padding: 2rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.rich-text-wrapper{
    &__editor{
        width: 100%;
    }
}

@media (max-width: 380px) {
    .type-activity{
        position: relative;
        .pagination-resources{
            position: static;
            .keyboard-return{
                position: absolute;
                top: 40px;
                left: 0;
                .btn-expand {
                    // margin: 0px 25px 0px 10px;
                    height: 30px;
                    width: 45px;
                }
            }
        }
    }
}
</style>
